export default {
    key: 'first-flyer',
    common: {
        productName: 'core.productNames.first-flyer',
        splashMessage: 'offerFlow.splashMessage.first-flyer',
        headingAside: 'offerFlow.headingAside.first-flyer',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.first-flyer',
        infoModal: {
            heading: 'offerFlow.pages.stepDate.infoModal.heading.first-flyer',
            body: 'offerFlow.pages.stepDate.infoModal.body.first-flyer',
        },
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.first-flyer',
        body: 'offerFlow.pages.stepPassengers.body.common',
        infoModal: {
            heading: 'offerFlow.pages.stepPassengers.infoModal.heading.first-flyer',
            body: 'offerFlow.pages.stepPassengers.infoModal.body.first-flyer',
        },
    },
} satisfies OfferFlowContent;
